var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryCharts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08333 5.83464C2.08333 5.60452 2.26988 5.41797 2.49999 5.41797H15.8333C16.0634 5.41797 16.25 5.60452 16.25 5.83464V7.91797H17.5C17.7301 7.91797 17.9167 8.10452 17.9167 8.33464V11.668C17.9167 11.8981 17.7301 12.0846 17.5 12.0846H16.25V14.168C16.25 14.3981 16.0634 14.5846 15.8333 14.5846H2.49999C2.26988 14.5846 2.08333 14.3981 2.08333 14.168V5.83464ZM2.91666 6.2513V13.7513H15.4167V11.668C15.4167 11.4378 15.6032 11.2513 15.8333 11.2513H17.0833V8.7513H15.8333C15.6032 8.7513 15.4167 8.56475 15.4167 8.33464V6.2513H2.91666Z",
    fill: "#76828F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74999 7.5013C3.74999 7.27118 3.93654 7.08464 4.16666 7.08464H7.49999C7.73011 7.08464 7.91666 7.27118 7.91666 7.5013V12.5013C7.91666 12.7314 7.73011 12.918 7.49999 12.918H4.16666C3.93654 12.918 3.74999 12.7314 3.74999 12.5013V7.5013Z",
    fill: "#76828F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharts);
export default __webpack_public_path__ + "static/media/battery_charts.98b0d3c4e17885a4ef842f7b4f6e651e.svg";
export { ForwardRef as ReactComponent };